import { render, staticRenderFns } from "./default.amp.vue?vue&type=template&id=157202b3&"
import script from "./default.amp.vue?vue&type=script&lang=js&"
export * from "./default.amp.vue?vue&type=script&lang=js&"
import style0 from "./default.amp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports